module.exports = __webpack_public_path__ + "img/invoice-de-male-ni.314a3736.png";